import ServiceError from '../../core/errors/ServiceError';

export default async function loadServiceGeo() {
  const url = process.env.URL_SERVICE_GEO;
  if (!url) {
    return new ServiceError('No hay url para servicio de Geo', '00123');
  }
  const response = await fetch(url, {
    method: 'GET',
  });
  let json;
  try {
    json = await response.json();
  } catch (error) {
    if (response?.status === 204) {
      return new ServiceError(
        'No hay contenido proporcionado por el servicio de VideoProducer',
        '00122',
      );
    }
    return new ServiceError('No se ha podido cargar el servicio de VideoProducer', '00121');
  }
  return json;
}
